import { NO_WEBSITE_ACTIVITY_DATE } from 'services/connectivity/configuration-api/properties/constants';

export function calculateFirstChat(firstChatValue: string | undefined): Date | null {
  if (!firstChatValue || firstChatValue === NO_WEBSITE_ACTIVITY_DATE || isNaN(new Date(firstChatValue).getTime())) {
    return null;
  }

  return new Date(firstChatValue);
}
